import { UserFormProps } from "../User.type";
import {
  Box,
  Button,
  Grid,
  Step,
  StepLabel,
  Stepper,
} from "../../../../shared/utils/muiImports";
import PersonalDetailsForm from "../pages/PersonalDetailsForm";
import ContactInformationForm from "../pages/ContactInformationForm";
import AdmissionInformationForm from "../pages/AdmissionInformationForm";

import StepperForm from "../../../../shared/components/StepperForm";
import { useRef, useState } from "react";
import { StepperFormRef } from "../../../../shared/types/StepperFormProps";
import { validateUserDetails } from "../UserValidation";

const UserForm: React.FC<UserFormProps> = ({
  user,
  onChange,
  onSave,
  onCancel,
  errors,
  setErrors,
  activeStep,
  setActiveStep,
}) => {
  const stepperRef = useRef<StepperFormRef>(null);

  const steps = [
    "Personal Details",
    "Contact Information",
    "Additional Information",
  ];

  const renderStepContent = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return (
          <Grid container spacing={3} mt={5}>
            <PersonalDetailsForm
              personalDetails={user}
              onChange={onChange}
              errors={errors.personalDetails}
            />
          </Grid>
        );
      case 1:
        return (
          <Grid container spacing={3} mt={5}>
            <ContactInformationForm
              contactDetails={user}
              onChange={onChange}
              errors={errors.contactDetails}
            />
          </Grid>
        );
      case 2:
        return (
          <Grid container spacing={3} mt={5}>
            <AdmissionInformationForm
              admissionDetails={user}
              onChange={onChange}
              errors={errors.additionalDetails}
            />
          </Grid>
        );
      default:
        return null;
    }
  };

  const handleStepChange = (isNext: boolean, step: number) => {
    console.log("old handleStepChange" + step);
    if (isNext) {
      setActiveStep((prev) => {
        const newStep = prev + 1;
        const errors = validateUserDetails(user, prev);

        if (Object.keys(errors.personalDetails).length > 0 && prev === 0) {
          setErrors({ personalDetails: errors.personalDetails });
          return prev;
        } else if (
          Object.keys(errors.contactDetails).length > 0 &&
          prev === 1
        ) {
          setErrors({ contactDetails: errors.contactDetails });
          return prev;
        } else {
          return newStep;
        }
      });
    } else {
      setActiveStep(step);
    }
    console.log("new handleStepChange" + step);
  };

  return (
    <>
      <Grid container spacing={3}>
        <StepperForm
          ref={stepperRef}
          initialData={user}
          steps={steps}
          renderStepContent={renderStepContent}
          onSubmit={onSave}
          onStepChange={handleStepChange}
          errors={errors}
        >
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ mt: 2, mb: 2, ml: 2 }}>
            {renderStepContent(activeStep)}
          </Box>
        </StepperForm>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
        <Button
          variant="outlined"
          onClick={() => stepperRef.current?.back()}
          disabled={activeStep === 0}
        >
          Back
        </Button>

        <Box sx={{ display: "flex", gap: 1 }}>
          {activeStep < steps.length - 1 && (
            <Button
              variant="outlined"
              onClick={() => stepperRef.current?.skip()}
            >
              Skip
            </Button>
          )}
          <Button
            variant="contained"
            onClick={() => {
              if (activeStep === steps.length - 1) {
                stepperRef.current?.save();
                setActiveStep(0);
              } else {
                stepperRef.current?.next();
              }
            }}
          >
            {activeStep === steps.length - 1 ? "Save" : "Next"}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            sx={{ width: 100 }}
            onClick={(e: any) => {
              onCancel(e);
              setActiveStep(0);
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default UserForm;
